import React, { createContext, ReactElement, useRef, useEffect } from "react";

type SaveInProgressWrapperProps = {
	handleSave: Function | undefined;
	children: ReactElement;
};

type SaveInProgressWrapperContextProps = {
	handleSave: Function | undefined;
};

export const SaveInProgressWrapperContext =
	createContext<SaveInProgressWrapperContextProps>({ handleSave: undefined });

export const SaveInProgressWrapper = ({
	handleSave,
	children,
}: SaveInProgressWrapperProps) => {
	const containerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (typeof handleSave !== "function") {
			return;
		}

		const inputs = Array.from(
			containerRef.current?.querySelectorAll("input, textarea") || [],
		);

		const handleEventFunctions = (item, eventFunction) => {
			const itemType = item.getAttribute("type");

			if (itemType === "radio" || itemType === "checkbox") {
				eventFunction("change", handleSave);
			} else {
				eventFunction("blur", handleSave);
			}
		};

		inputs.forEach(item => {
			handleEventFunctions(item, item.addEventListener);
		});

		return () => {
			inputs.forEach(item => {
				handleEventFunctions(item, item.removeEventListener);
			});
		};
	}, [handleSave, children]);

	return (
		<div ref={containerRef}>
			<SaveInProgressWrapperContext.Provider value={{ handleSave }}>
				{children}
			</SaveInProgressWrapperContext.Provider>
		</div>
	);
};
